import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
import {formatInt} from "../../../filters";

Vue.use(Vuex);

const state = {
    report_filters: {
        report_type_code: '',
        use_invoice: 0,
        date_from: '',
        date_to: '',
        store_id: 0,
    },
    stock_report_filters: {
        category_id: '',
        subcategory_id: '',
        date_from: '',
        date_to: '',
    },
    stock_out_filters: {
        store_id: '',
        barcode: '',
        date_from: '',
        date_to: '',
    },
    reportData: {},
}

const actions = {
    getReport({commit}, payload) {
        commit('setLoadingStatus', true);
        axios.get('/api'+payload.url, {
            params: payload.filters,
        }).then((response) => {
            commit('setReport', response.data);
            commit('setLoadingStatus', false);
        }).catch((e) => {
            commit('setLoadingStatus', false);
        });
    },
    getStockOut({commit}, payload) {
        commit('setLoadingStatus', true);
        axios.get('/api/reports/stock-out-report', {
            params: payload.filters,
        }).then((response) => {
            commit('setReport', response.data.data);
            commit('setPagination', response.data.pagination);
            commit('setLoadingStatus', false);
        }).catch((e) => {
            commit('setLoadingStatus', false);
        });
    },
}

const mutations = {
    setReportFilters(state, payload) {
        state.report_filters = payload;
    },
    setStockReportFilters(state, payload) {
        state.stock_report_filters = payload;
    },
    setStockOutFilters(state, payload) {
        state.stock_out_filters = payload;
    },
    setReport(state, payload) {
        state.reportData = payload;
    },
}

const getters = {
    report: function(state) {
        return state.reportData;
    },
    reportItems: function(state) {
        if(state.reportData) {
            if(state.reportData[0]) {
                let keys = Object.keys(state.reportData[0]);
                keys.splice(0,1);
                return keys;
            }
        }
    },
    reportFilters: state => state.report_filters,
    stockReportFilters: state => state.stock_report_filters,
    stockOutFilters: state => state.stock_out_filters,
}

export const reportStore = {
    state,
    actions,
    mutations,
    getters
}